<p>window-loader works!</p>
